import { IceBreakerChannel, iceBreakerChannelSchema } from 'shared/api/requests/iceBreakers/schemas'

export const isIceBreakerChannel = (channel: unknown): channel is IceBreakerChannel =>
  iceBreakerChannelSchema.safeParse(channel).success
